module.exports = __webpack_public_path__ + "media/images/replay-ec95e84c9e6bcea9f7d079c365902723.png";